import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { AffiliateData, AffiliateWithdrawLogParams } from '../payment.types';

const getAffiliateLog = (client: AxiosInstance) => async (params: AffiliateWithdrawLogParams) => {
  return (
    await client.get<PaginatedApiResponse<AffiliateData[]>>(API_ROUTES.GET_AFFILIATE_WITHDRAW_LOG, {
      params,
    })
  ).data;
};

export const affiliateLogQueries = {
  all: () => [API_ROUTES.GET_AFFILIATE_WITHDRAW_LOG],

  list: (params: AffiliateWithdrawLogParams) =>
    queryFactoryOptions<PaginatedApiResponse<AffiliateData[]>>({
      queryKey: [...affiliateLogQueries.all(), 'list', params],
      queryFn: (client) => () => getAffiliateLog(client)(params),
    }),
};
